export const logChangesTableColumns = [
  { label: "Data e hora", value: "created_at", className: "w-32" },
  { label: "Autor", value: "full_name" },
  { label: "Ação", value: "description", className: "min-w-[300px]" },
  { label: "Objeto", value: "item_name_translated" },
  { label: "Alteração", value: "changes", className: "p-0" },
  { label: "Antes", value: "changes_before", className: "p-0" },
  { label: "Depois", value: "changes_after", className: "p-0" },
  { label: "Ações", value: "actions", className: "w-9" },
];
